var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { trim, includes } from 'lodash';
import { classNames, ginni } from '@shapeable/utils';
// @ts-ignore
import SITE_HEADER_LAYOUT_BG from '../images/site-header-layout-bg.png';
import { useSiteHeader } from '../hooks/use-site-header';
import { DownloadAltIconGlyph, GlobeIconGlyph, HeartIconGlyph, LightGlobeOffIconGlyph, LightGlobeOnIconGlyph, MenuIconGlyph, PersonIconGlyph, SearchIconGlyph, ShareIconGlyph, useIcons } from '@shapeable/icons';
import { SliceLayout } from './slice-layout';
import { SiteHeaderUtilityButton } from './site-header-utility-button';
import { SiteSearch } from '../elements/site-search';
import { SiteMenuBar } from './site-menu-bar';
import { Icon } from '../elements/icon';
import { SiteHeaderLogo } from './site-header-logo';
import { MenuItemLink } from './menu-item-link';
import { NavigationMenuItem } from '../elements/navigation-menu-item';
import { ImageBubble } from '../elements/image-bubble';
import { UtilityMenu } from '../elements/utility-menu';
import { LangMenu } from './site-lang-menu';
import { ShareMenu } from '../elements/share-menu';
import { FollowMenu } from '../elements/follow-menu';
import { UserMenu } from '../elements/user-menu';
import { SiteMenuReveal } from './site-menu-reveal';
import { NavigationMenu } from '../elements/navigation-menu';
import { useMainMenu } from '../hooks/use-main-menu';
import { useSite } from '../hooks/use-site';
import { useModal } from '../hooks/use-modal';
import { useSiteMenuBar } from '../hooks/use-site-menu-bar';
import { useLang } from '../hooks/use-lang';
import { useEnv } from '../hooks/use-env';
import { useSiteSearch } from '../hooks/use-site-search';
import { useActiveEntity } from '../hooks/use-active-entity';
import { usePageEntity } from '../hooks/use-page-entity';
import { useAuth } from '../hooks/use-auth';
import { useActiveLang } from '../hooks/use-active-lang';
import { useUserMenu } from '../hooks/use-user-menu';
import { DarkMode, ThemeModeProvider } from '../context/theme-mode-context';
import { SiteLangMenuButton } from './site-lang-menu-button';
import { useComponentPropsFor } from '../context/component-props-context';
import { useThemeEval } from '../hooks/use-theme-eval';
import * as polished from 'polished';
import { useIsDarkColor } from '../hooks/use-is-dark-color';
import { ThemeModeMenu } from '../elements/theme-mode-menu';
import { useActiveThemeMode } from '../hooks/use-active-theme-mode';
var cls = classNames('site-header-layout');
export var SiteHeaderLayoutDefaultProps = {
  showOverlayGradient: true,
  useLogoVerticalOffsets: true,
  colors: {
    background: 'bright',
    text: 'strong'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n    ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    font-weight: 500;\n    font-size: ", ";\n\n    .shp--slice-layout {\n      flex-grow: 1;\n    }\n\n    .shp--slice-layout__boundary {\n      height: 100%;\n    }\n\n    ", "\n  "], ["\n    ", "\n    ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    font-weight: 500;\n    font-size: ", ";\n\n    .shp--slice-layout {\n      flex-grow: 1;\n    }\n\n    .shp--slice-layout__boundary {\n      height: 100%;\n    }\n\n    ", "\n  "])), function (_a) {
    var heightMobile = _a.heightMobile;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightMobile);
  }, theme.APPLY_COLORS, theme.FONT_SIZE(15), function (_a) {
    var showOverlayGradient = _a.showOverlayGradient;
    return showOverlayGradient && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-image: url(", ");\n      background-repeat: repeat-x;\n      background-position: bottom left;\n    "], ["\n      background-image: url(", ");\n      background-repeat: repeat-x;\n      background-position: bottom left;\n    "])), SITE_HEADER_LAYOUT_BG);
  }),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var heightTablet = _a.heightTablet;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightTablet);
  }),
  desktop: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var heightDesktop = _a.heightDesktop;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightDesktop);
  }),
  last: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    @media (max-width: 360px) {\n      .shp--text-bubble {\n        width: 24px;\n        height: 24px;\n        font-size: 0.6em; \n      }\n    }\n  "], ["\n    @media (max-width: 360px) {\n      .shp--text-bubble {\n        width: 24px;\n        height: 24px;\n        font-size: 0.6em; \n      }\n    }\n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-grow: 1;\n    flex-direction: row;\n    align-self: stretch;\n    justify-self: stretch;\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-grow: 1;\n    flex-direction: row;\n    align-self: stretch;\n    justify-self: stretch;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    align-self: stretch;\n    align-items: stretch;\n    flex-direction: column;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    align-self: stretch;\n    align-items: stretch;\n    flex-direction: column;\n    justify-content: space-between;\n  "])))
});
var NavigationAndControlsStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: none;\n    width: 100%;\n    flex-grow: 1;\n    align-self: stretch;\n    align-items: center;\n    box-sizing: border-box;\n    height: 100%;\n\n    ", "\n\n    box-sizing: border-box;\n  "], ["\n    display: none;\n    width: 100%;\n    flex-grow: 1;\n    align-self: stretch;\n    align-items: center;\n    box-sizing: border-box;\n    height: 100%;\n\n    ", "\n\n    box-sizing: border-box;\n  "])), function (_a) {
    var variant = _a.variant;
    return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      padding-top: ", ";\n    "], ["\n      padding-top: ", ";\n    "])), theme.UNIT(2.5));
  }),
  desktop: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var NavigationStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    font-size: 1em;\n    list-style: none;\n    margin: 0;\n    display: none;\n    align-self: stretch;\n    height: 100%;\n    padding-left: ", ";\n  "], ["\n    font-size: 1em;\n    list-style: none;\n    margin: 0;\n    display: none;\n    align-self: stretch;\n    height: 100%;\n    padding-left: ", ";\n  "])), theme.UNIT(6)),
  desktop: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var LogoStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    align-self: center;\n  "], ["\n    align-self: center;\n  "])))
});
var NavigationItemStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    padding: 0 ", ";\n    position: relative;\n  "], ["\n    padding: 0 ", ";\n    position: relative;\n  "])), theme.UNIT(1.5))
});
var MenuItemLinkStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    height: 100%;\n    box-sizing: border-box;\n    ", "\n  "], ["\n    height: 100%;\n    box-sizing: border-box;\n    ", "\n  "])), function (_a) {
    var isDisclosed = _a.isDisclosed;
    return css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      .shp--icon {\n        margin-top: -2px;\n        transform: rotate(", ");\n      }\n    "], ["\n      .shp--icon {\n        margin-top: -2px;\n        transform: rotate(", ");\n      }\n    "])), isDisclosed ? '180deg' : '0deg');
  })
});
var NavigationItemChildrenStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    position: absolute;\n    left: 6px;\n    top: 57px;\n    margin: 0;\n    list-style: none;\n    padding: ", " 0 ", " 0;\n    border-top: 1px solid #FFF;\n    box-shadow: 1px 2px 6px -1px rgba(0,0,0,0.5);\n    background: rgba(0, 0, 0, 1.0);\n    z-index: 100;\n    border-radius: 0 0 ", " ", ";\n  "], ["\n    position: absolute;\n    left: 6px;\n    top: 57px;\n    margin: 0;\n    list-style: none;\n    padding: ", " 0 ", " 0;\n    border-top: 1px solid #FFF;\n    box-shadow: 1px 2px 6px -1px rgba(0,0,0,0.5);\n    background: rgba(0, 0, 0, 1.0);\n    z-index: 100;\n    border-radius: 0 0 ", " ", ";\n  "])), theme.UNIT(1), theme.UNIT(3), theme.UNIT(3), theme.UNIT(3))
});
var MenuItemSubLinkStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    a {\n      padding-left: ", ";\n      padding-right: ", ";\n    }\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    .shp--menu-item-link__label {\n      white-space: wrap;\n    }\n  "], ["\n    a {\n      padding-left: ", ";\n      padding-right: ", ";\n    }\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    .shp--menu-item-link__label {\n      white-space: wrap;\n    }\n  "])), theme.UNIT(3.5), theme.UNIT(4))
});
var MenuItemLinkChildStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n    width: 100%;\n    font-weight: 300;\n    width: 200px;\n    display: block;\n    text-shadow: 0 1px 0 rgba(0,0,0,0.3);\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "], ["\n    margin: 0 0 ", " 0;\n    width: 100%;\n    font-weight: 300;\n    width: 200px;\n    display: block;\n    text-shadow: 0 1px 0 rgba(0,0,0,0.3);\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "])), theme.UNIT(4))
});
var MenuButtonStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    cursor: pointer;\n    width: 24px;\n    height: 24px;\n    display: none;\n    margin-left: ", ";\n    margin-right: ", ";\n    display: block;\n\n    .shp--image-bubble {\n      width: 100% !important;\n      height: 100% !important;\n    }\n  "], ["\n    ", ";\n    ", ";\n    cursor: pointer;\n    width: 24px;\n    height: 24px;\n    display: none;\n    margin-left: ", ";\n    margin-right: ", ";\n    display: block;\n\n    .shp--image-bubble {\n      width: 100% !important;\n      height: 100% !important;\n    }\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.APPLY_COLORS, theme.UNIT(4), theme.UNIT(1)),
  tablet: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    width: 24px;\n    height: 24px;\n    display: block;\n\n  "], ["\n    width: 24px;\n    height: 24px;\n    display: block;\n\n  "]))),
  last: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    @media (max-width: 360px) {\n      width: 24px;\n      height: 24px;\n      margin-left: ", ";\n    }\n  "], ["\n    @media (max-width: 360px) {\n      width: 24px;\n      height: 24px;\n      margin-left: ", ";\n    }\n  "])), theme.UNIT(2))
});
var ThemeModeMenuButtonStyles = breakpoints({
  base: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    ", ";\n    margin-top: -3px;\n    \n    ", "\n\n    width: 24px;\n    height: 24px;\n\n  "], ["\n    ", ";\n    margin-top: -3px;\n    \n    ", "\n\n    width: 24px;\n    height: 24px;\n\n  "])), MenuButtonStyles, function (props) {
    return props.menuTarget !== 'menu-bar' && css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n      margin-top: -6px;\n    "], ["\n      margin-top: -6px;\n    "])));
  }),
  tablet: css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    width: 20px;\n    height: 20px;\n  "], ["\n    width: 20px;\n    height: 20px;\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var UtilityButtonsStyles = breakpoints({
  base: css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    display: none;\n    flex-direction: row;\n    flex-shrink: 0;\n    align-items: center;\n    height: 32px;\n    align-self: flex-end;\n  "], ["\n    display: none;\n    flex-direction: row;\n    flex-shrink: 0;\n    align-items: center;\n    height: 32px;\n    align-self: flex-end;\n  "]))),
  desktop: css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var MenuButtonsStyles = breakpoints({
  base: css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n    align-self: flex-end;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    position: relative;\n  "], ["\n    align-self: flex-end;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    position: relative;\n  "]))),
  tablet: css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(3)),
  desktop: css(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var UtilityButtonStyles = breakpoints({
  base: css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    margin-left: ", ";\n    position: relative;\n    &:first-child {\n      margin-left: 0;\n    }\n  "], ["\n    margin-left: ", ";\n    position: relative;\n    &:first-child {\n      margin-left: 0;\n    }\n  "])), theme.UNIT(2))
});
var LangUtilityButtonStyles = breakpoints({
  base: css(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n    ", ";\n    ", ",\n    ", " {\n      width: 62px; \n    }\n  "], ["\n    ", ";\n    ", ",\n    ", " {\n      width: 62px; \n    }\n  "])), UtilityButtonStyles, SiteHeaderUtilityButton.cls.child('button'), SiteHeaderUtilityButton.cls.child('menu-button'))
});
var SearchUtilityButtonStyles = breakpoints({
  base: css(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), UtilityButtonStyles)
});
var HeadEndStyles = breakpoints({
  base: css(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n    position: relative;\n\n  "], ["\n    position: relative;\n\n  "])))
});
var ShareMenuStyles = breakpoints({
  base: css(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n    box-sizing: border-box;\n    overflow: auto;\n  "], ["\n    box-sizing: border-box;\n    overflow: auto;\n  "])))
});
var FollowMenuStyles = breakpoints({
  base: css(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n    box-sizing: border-box;\n    overflow: auto;\n  "], ["\n    box-sizing: border-box;\n    overflow: auto;\n  "])))
});
var UtilityMenuStyles = breakpoints({
  base: css(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n    box-sizing: border-box;\n    overflow: auto;\n  "], ["\n    box-sizing: border-box;\n    overflow: auto;\n  "])))
});
var UserMenuStyles = breakpoints({
  base: css(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n    box-sizing: border-box;\n    overflow: auto;\n  "], ["\n    box-sizing: border-box;\n    overflow: auto;\n  "])))
});
var ThemeModeMenuStyles = breakpoints({
  base: css(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LangMenuRevealStyles = breakpoints({
  base: css(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ShareMenuRevealStyles = breakpoints({
  base: css(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FollowMenuRevealStyles = breakpoints({
  base: css(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var NavigationMenuRevealStyles = breakpoints({
  base: css(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ThemeModeMenuRevealStyles = breakpoints({
  base: css(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var UserMenuRevealStyles = breakpoints({
  base: css(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var NavigationMenuStyles = breakpoints({
  base: css(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n    padding: ", " 0 0;\n    font-size: 1em;\n    list-style: none;\n    z-index: 100;\n    margin: 0;\n    min-width: 300px;\n  "], ["\n    padding: ", " 0 0;\n    font-size: 1em;\n    list-style: none;\n    z-index: 100;\n    margin: 0;\n    min-width: 300px;\n  "])), theme.UNIT(1))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LangMenuStyles = breakpoints({
  base: css(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MenuBarStyles = breakpoints({
  base: css(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n    position: fixed;\n    top: -100px;\n    z-index: 300;\n    left: 0;\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    position: fixed;\n    top: -100px;\n    z-index: 300;\n    left: 0;\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var showShadow = _a.showShadow;
    return showShadow && css(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n      border-bottom: 1px solid ", ";\n      box-shadow: 0 1px 3px -4px rgba(0,0,0,0.7);\n    "], ["\n      border-bottom: 1px solid ", ";\n      box-shadow: 0 1px 3px -4px rgba(0,0,0,0.7);\n    "])), theme.COLOR('justVisible'));
  }, function (_a) {
    var slideDownDuration = _a.slideDownDuration;
    return css(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n      transition: top ", "s;\n    "], ["\n      transition: top ", "s;\n    "])), slideDownDuration);
  }, function (_a) {
    var isVisible = _a.isVisible,
      slideDownDuration = _a.slideDownDuration;
    return isVisible && css(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n      top: 0;\n    "], ["\n      top: 0;\n    "])));
  })
});
var LangMenuButtonStyles = breakpoints({
  base: css(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var UserImageStyles = breakpoints({
  base: css(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n    margin-top: -1px;\n  "], ["\n    margin-top: -1px;\n  "])))
});
var UserButtonImageStyles = breakpoints({
  base: css(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n    margin-top: -1px;\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n  "], ["\n    margin-top: -1px;\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n  "]))),
  last: css(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n    @media (max-width: 360px) {\n      border-width: 2px;\n    }\n  "], ["\n    @media (max-width: 360px) {\n      border-width: 2px;\n    }\n  "])))
});
var SiteSearchStyles = breakpoints({
  base: css(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SiteHeaderLayout',
  Container: styled.div(templateObject_62 || (templateObject_62 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SiteSearch: styled(SiteSearch)(templateObject_63 || (templateObject_63 = __makeTemplateObject(["", ""], ["", ""])), SiteSearchStyles),
  MenuBar: styled(SiteMenuBar)(templateObject_64 || (templateObject_64 = __makeTemplateObject(["", ""], ["", ""])), MenuBarStyles),
  Icon: styled(Icon)(templateObject_65 || (templateObject_65 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Layout: styled.div(templateObject_66 || (templateObject_66 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Logo: styled(SiteHeaderLogo)(templateObject_67 || (templateObject_67 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  UtilityButtons: styled.div.attrs(cls.attr('utility-buttons'))(templateObject_68 || (templateObject_68 = __makeTemplateObject(["", ""], ["", ""])), UtilityButtonsStyles),
  UtilityButton: styled(SiteHeaderUtilityButton)(templateObject_69 || (templateObject_69 = __makeTemplateObject(["", ""], ["", ""])), UtilityButtonStyles),
  LangUtilityButton: styled(SiteHeaderUtilityButton)(templateObject_70 || (templateObject_70 = __makeTemplateObject(["", ""], ["", ""])), LangUtilityButtonStyles),
  SearchUtilityButton: styled(SiteHeaderUtilityButton)(templateObject_71 || (templateObject_71 = __makeTemplateObject(["", ""], ["", ""])), SearchUtilityButtonStyles),
  HeadEnd: styled.div.attrs(cls.attr('head-end'))(templateObject_72 || (templateObject_72 = __makeTemplateObject(["", ""], ["", ""])), HeadEndStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_73 || (templateObject_73 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  NavigationAndControls: styled.div.attrs(cls.attr('navigation-and-controls'))(templateObject_74 || (templateObject_74 = __makeTemplateObject(["", ""], ["", ""])), NavigationAndControlsStyles),
  Navigation: styled.ul.attrs(cls.attr('navigation'))(templateObject_75 || (templateObject_75 = __makeTemplateObject(["", ""], ["", ""])), NavigationStyles),
  NavigationItem: styled.li.attrs(cls.attr('navigation-item'))(templateObject_76 || (templateObject_76 = __makeTemplateObject(["", ""], ["", ""])), NavigationItemStyles),
  MenuItemLink: styled(MenuItemLink)(templateObject_77 || (templateObject_77 = __makeTemplateObject(["", ""], ["", ""])), MenuItemLinkStyles),
  NavigationItemChildren: styled.ul.attrs(cls.attr('navigation-item-children'))(templateObject_78 || (templateObject_78 = __makeTemplateObject(["", ""], ["", ""])), NavigationItemChildrenStyles),
  NavigationItemChild: styled.li.attrs(cls.attr('navigation-item-child'))(templateObject_79 || (templateObject_79 = __makeTemplateObject(["", ""], ["", ""])), MenuItemLinkChildStyles),
  //                  MenuItemSubLink: styled(MenuItemLink)`${MenuItemSubLinkStyles}`,
  MenuItemSubLink: styled(NavigationMenuItem)(templateObject_80 || (templateObject_80 = __makeTemplateObject(["", ""], ["", ""])), MenuItemSubLinkStyles),
  Controls: styled.div.attrs(cls.attr('controls'))(templateObject_81 || (templateObject_81 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  LangMenuButton: styled(SiteLangMenuButton).attrs(cls.attr('lang-menu-button'))(templateObject_82 || (templateObject_82 = __makeTemplateObject(["", ""], ["", ""])), LangMenuButtonStyles),
  UserImage: styled(ImageBubble)(templateObject_83 || (templateObject_83 = __makeTemplateObject(["", ""], ["", ""])), UserImageStyles),
  MenuButtons: styled.div.attrs(cls.attr('menu-buttons'))(templateObject_84 || (templateObject_84 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonsStyles),
  MenuButton: styled.button.attrs(cls.attr('menu-button'))(templateObject_85 || (templateObject_85 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  SearchButton: styled.button.attrs(cls.attr('search-button'))(templateObject_86 || (templateObject_86 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  ShareButton: styled.button.attrs(cls.attr('share-button'))(templateObject_87 || (templateObject_87 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  UtilityMenuButton: styled.button.attrs(cls.attr('utility-menu-button'))(templateObject_88 || (templateObject_88 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  FollowButton: styled.button.attrs(cls.attr('follow-button'))(templateObject_89 || (templateObject_89 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  LangButton: styled.button.attrs(cls.attr('lang-button'))(templateObject_90 || (templateObject_90 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  UserButton: styled.button.attrs(cls.attr('user-button'))(templateObject_91 || (templateObject_91 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  ThemeModeButton: styled.button.attrs(cls.attr('theme-mode-button'))(templateObject_92 || (templateObject_92 = __makeTemplateObject(["", ""], ["", ""])), ThemeModeMenuButtonStyles),
  UserButtonImage: styled(ImageBubble)(templateObject_93 || (templateObject_93 = __makeTemplateObject(["", ""], ["", ""])), UserButtonImageStyles),
  UtilityMenu: styled(UtilityMenu)(templateObject_94 || (templateObject_94 = __makeTemplateObject(["", ""], ["", ""])), UtilityMenuStyles),
  LangMenu: styled(LangMenu)(templateObject_95 || (templateObject_95 = __makeTemplateObject(["", ""], ["", ""])), LangMenuStyles),
  ShareMenu: styled(ShareMenu)(templateObject_96 || (templateObject_96 = __makeTemplateObject(["", ""], ["", ""])), ShareMenuStyles),
  FollowMenu: styled(FollowMenu)(templateObject_97 || (templateObject_97 = __makeTemplateObject(["", ""], ["", ""])), FollowMenuStyles),
  UserMenu: styled(UserMenu)(templateObject_98 || (templateObject_98 = __makeTemplateObject(["", ""], ["", ""])), UserMenuStyles),
  ThemeModeMenu: styled(ThemeModeMenu)(templateObject_99 || (templateObject_99 = __makeTemplateObject(["", ""], ["", ""])), ThemeModeMenuStyles),
  UtilityMenuReveal: styled(SiteMenuReveal)(templateObject_100 || (templateObject_100 = __makeTemplateObject(["", ""], ["", ""])), ShareMenuRevealStyles),
  ShareMenuReveal: styled(SiteMenuReveal)(templateObject_101 || (templateObject_101 = __makeTemplateObject(["", ""], ["", ""])), ShareMenuRevealStyles),
  LangMenuReveal: styled(SiteMenuReveal)(templateObject_102 || (templateObject_102 = __makeTemplateObject(["", ""], ["", ""])), LangMenuRevealStyles),
  FollowMenuReveal: styled(SiteMenuReveal)(templateObject_103 || (templateObject_103 = __makeTemplateObject(["", ""], ["", ""])), FollowMenuRevealStyles),
  UserMenuReveal: styled(SiteMenuReveal)(templateObject_104 || (templateObject_104 = __makeTemplateObject(["", ""], ["", ""])), UserMenuRevealStyles),
  ThemeModeMenuReveal: styled(SiteMenuReveal)(templateObject_105 || (templateObject_105 = __makeTemplateObject(["", ""], ["", ""])), ThemeModeMenuRevealStyles),
  NavigationMenuReveal: styled(SiteMenuReveal)(templateObject_106 || (templateObject_106 = __makeTemplateObject(["", ""], ["", ""])), NavigationMenuRevealStyles),
  NavigationMenu: styled(NavigationMenu)(templateObject_107 || (templateObject_107 = __makeTemplateObject(["", ""], ["", ""])), NavigationMenuStyles)
};
/* @ts-ignore */
export var SiteHeaderLayout = React.forwardRef(function (props, containerRef) {
  var _a;
  var _b = useComponentPropsFor(My.NAME, SiteHeaderLayoutDefaultProps, props),
    className = _b.className,
    maxLogoHeight = _b.maxLogoHeight,
    showOverlayGradient = _b.showOverlayGradient,
    useLogoVerticalOffsets = _b.useLogoVerticalOffsets,
    colors = _b.colors;
  ginni.verbose.group("SiteHeaderLayout");
  ginni.verbose.log("Props: ", props);
  var menu = useMainMenu();
  var header = useSiteHeader();
  var site = useSite();
  var modal = useModal();
  var variant = header.variant;
  var colorsToUse = variant === 'overlay' ? {
    background: 'transparent',
    text: 'strong'
  } : colors;
  var t = useLang();
  var env = useEnv();
  var isMenuBarVisible = header.isMenuBarVisible;
  var headerHeightMobile = site.headerHeightMobile,
    headerHeightTablet = site.headerHeightTablet,
    headerHeightDesktop = site.headerHeightDesktop,
    _c = site.headerButtons,
    headerButtons = _c === void 0 ? [] : _c;
  var activeThemeMode = useActiveThemeMode();
  var $ = useThemeEval();
  var menuBar = useSiteMenuBar();
  var search = useSiteSearch();
  var Icons = useIcons();
  var currentEntity = useActiveEntity();
  var pageEntity = usePageEntity();
  var auth = useAuth();
  var showSearch = search.isAvailable && !(search.requiresAuthentication && !auth.isAuthenticated);
  ginni.verbose.log("Auth:", auth);
  ginni.verbose.log("Search:", search);
  ginni.verbose.log("Show Search: ", showSearch);
  var boundary = props.boundary || header.boundary || 'content';
  var sliceEntity = __assign(__assign({}, currentEntity), {
    backgroundColor: {
      id: 'bg',
      value: colorsToUse === null || colorsToUse === void 0 ? void 0 : colorsToUse.background
    },
    color: {
      id: 'text',
      value: colorsToUse === null || colorsToUse === void 0 ? void 0 : colorsToUse.text
    }
  });
  var activeLang = useActiveLang();
  var imageUrl = useUserMenu().imageUrl;
  var isDarkColor = useIsDarkColor({
    colors: colorsToUse,
    key: 'background'
  });
  var isInverted = variant === 'overlay' || isDarkColor;
  var themeMode = isInverted ? 'dark' : 'light';
  var logoProps = {
    isInverted: isInverted,
    variant: isInverted ? 'inverted' : 'default',
    maxHeight: maxLogoHeight,
    useVerticalOffsets: useLogoVerticalOffsets
  };
  var UserButtonIcon = function (props) {
    var _a;
    var userImageUrl = imageUrl || ((_a = auth.user) === null || _a === void 0 ? void 0 : _a.picture);
    if (userImageUrl) {
      return React.createElement(My.UserButtonImage, __assign({}, props, {
        image: {
          url: userImageUrl
        }
      }));
    }
    return React.createElement(My.Icon, null, React.createElement(PersonIconGlyph, __assign({}, props)));
  };
  // TODO - fix this
  var canShowMenuBar = true; // !map.isVisible
  /* Menu Buttons are the small icon buttons which appear in the mobile header and menu bar */
  var menuButtons = function (target) {
    var colors = {
      stroke: 'strong',
      hover: {
        stroke: 'strong'
      }
    };
    // target === 'header' ? header.menuButtonColor : menuBar.buttonColor;
    return React.createElement(React.Fragment, null, header.showUtilities && React.createElement(My.UtilityMenuButton, {
      colors: colors,
      onClick: header.onUtilityMenuButtonClick
    }, React.createElement(My.Icon, {
      size: 24
    }, React.createElement(DownloadAltIconGlyph, null))), header.showUser && React.createElement(My.UserButton, {
      colors: colors,
      onClick: header.onUserButtonClick
    }, React.createElement(UserButtonIcon, {
      colors: colors
    })), search.isAvailable && React.createElement(My.SearchButton, {
      colors: colors,
      onClick: function () {
        search.toggle();
      }
    }, React.createElement(My.Icon, null, React.createElement(SearchIconGlyph, null))), React.createElement(My.MenuButton, {
      menuTarget: target,
      colors: colors,
      onClick: header.onMenuButtonClick
    }, React.createElement(My.Icon, null, React.createElement(MenuIconGlyph, null))));
  };
  var onMenuItemClick = function (item) {
    header.setDisclosedMenuItem(item.id);
  };
  ginni.verbose.groupEnd();
  var navigationMenu = React.createElement(My.NavigationMenu, {
    onItemClick: onMenuItemClick,
    itemIsAvailable: header.menuItemIsAvailable,
    isVisible: header.isNavigationMenuVisible,
    items: header.navigationMenuItems,
    mobileChildren: React.createElement(React.Fragment, null, env.ENABLE_LANG && React.createElement(My.LangMenu, {
      onItemClick: function () {
        header.hideNavigationMenu();
      },
      showTitle: true
    }), header.showThemeMode && React.createElement(My.ThemeModeMenu, {
      onItemClick: function () {
        header.hideNavigationMenu();
      },
      showTitle: true
    }), header.showFollow && React.createElement(My.FollowMenu, {
      onItemClick: function () {
        header.hideNavigationMenu();
      },
      showTitle: true
    }), header.showShare && React.createElement(My.ShareMenu, {
      onItemClick: function () {
        header.hideNavigationMenu();
      },
      showTitle: true
    }))
  });
  var pinnedNavigationMenu = React.createElement(My.NavigationMenu, {
    ref: header.pinnedNavigationMenuRef,
    onItemClick: onMenuItemClick,
    isVisible: header.isPinnedNavigationMenuVisible,
    items: header.pinnedNavigationMenuItems
  });
  var headerButtonsVariant = function (variant) {
    var hasMenu = !(variant === 'pinned' && isMenuBarVisible || variant !== 'pinned' && !isMenuBarVisible);
    // const color = variant === 'pinned' ? header.menuButtonColor : menuBar.buttonColor;
    var colors = {
      text: 'strong'
    };
    return React.createElement(React.Fragment, null, headerButtons.map(function (link) {
      var _a, _b, _c, _d, _e;
      var href = link.url || ((_a = link.page) === null || _a === void 0 ? void 0 : _a.path);
      var linkColor = (_b = link.color) === null || _b === void 0 ? void 0 : _b.value;
      var buttonColors = __assign(__assign({}, colors), {
        background: linkColor,
        hover: linkColor ? {
          background: polished.darken(0.05, linkColor)
        } : {}
      });
      return React.createElement(My.UtilityButton, {
        key: "".concat(variant, "-").concat(link.id),
        colors: buttonColors,
        variant: variant,
        onClick: !href && function () {
          header.onHeaderButtonClick(link.slug);
        },
        href: href,
        /* @ts-ignore */
        iconComponent: Icons[(_c = link.icon) === null || _c === void 0 ? void 0 : _c.component]
      }, link.label || ((_d = link.page) === null || _d === void 0 ? void 0 : _d.title) || ((_e = link.page) === null || _e === void 0 ? void 0 : _e.name) || link.name);
    }), search.isAvailable && !(search.requiresAuthentication && !auth.isAuthenticated) && React.createElement(My.SearchUtilityButton, {
      colors: colors,
      iconComponent: SearchIconGlyph,
      variant: variant,
      isMenuVisible: false,
      onClick: function () {
        search.toggle();
      }
    }, t('Search')), header.showUtilities && React.createElement(My.UtilityButton, {
      menu: hasMenu && React.createElement(My.UtilityMenu, {
        onItemClick: header.onUtilityMenuButtonClick,
        ref: header.utilityMenuRef,
        items: header.utilityMenu
      }),
      colors: colors,
      isMenuVisible: header.isUtilityMenuVisible,
      variant: variant,
      iconComponent: DownloadAltIconGlyph,
      onClick: header.onUtilityMenuButtonClick
    }, t('Download PDF')), env.ENABLE_LANG && React.createElement(My.LangUtilityButton, {
      colors: colors,
      iconComponent: GlobeIconGlyph,
      variant: variant,
      menu: hasMenu && React.createElement(My.LangMenu, {
        ref: header.langMenuRef
      }),
      isMenuVisible: header.isLangMenuVisible,
      onClick: header.onLangButtonClick
    }, t(activeLang.iso.toUpperCase())), header.showFollow && React.createElement(My.UtilityButton, {
      menu: hasMenu && React.createElement(My.FollowMenu, {
        onItemClick: header.onFollowButtonClick,
        ref: header.followMenuRef
      }),
      colors: colors,
      isMenuVisible: header.isFollowMenuVisible,
      iconComponent: HeartIconGlyph,
      variant: variant,
      onClick: header.onFollowButtonClick
    }, t('Follow Us')), header.showShare && React.createElement(My.UtilityButton, {
      menu: hasMenu && React.createElement(My.ShareMenu, {
        onItemClick: header.onShareButtonClick,
        ref: header.shareMenuRef
      }),
      colors: colors,
      isMenuVisible: header.isShareMenuVisible,
      iconComponent: ShareIconGlyph,
      variant: variant,
      onClick: header.onShareButtonClick
    }, t('Share')), header.showUser && React.createElement(My.UtilityButton, {
      menu: hasMenu && React.createElement(My.UserMenu, {
        onItemClick: header.onUserButtonClick,
        ref: header.userMenuRef
      }),
      colors: colors,
      isMenuVisible: header.isUserMenuVisible,
      iconComponent: PersonIconGlyph,
      variant: variant,
      onClick: header.onUserButtonClick
    }, header.userLabel), header.showThemeMode && React.createElement(My.UtilityButton, {
      menu: hasMenu && React.createElement(My.ThemeModeMenu, {
        onItemClick: header.onThemeModeButtonClick,
        ref: header.themeModeMenuRef
      }),
      colors: colors,
      isMenuVisible: header.isThemeModeMenuVisible,
      iconComponent: activeThemeMode.isDark ? LightGlobeOffIconGlyph : LightGlobeOnIconGlyph,
      variant: variant,
      onClick: header.onThemeModeButtonClick
    }));
  };
  return React.createElement(My.Container, {
    colors: colorsToUse,
    ref: containerRef || header.ref,
    showOverlayGradient: variant === "overlay" && showOverlayGradient,
    className: cls.name(className),
    heightMobile: headerHeightMobile,
    heightTablet: headerHeightTablet,
    heightDesktop: headerHeightDesktop
  }, search.isVisible && React.createElement(My.SiteSearch, null), React.createElement(My.MenuBar, {
    entity: pageEntity,
    showShadow: menuBar.showShadow,
    slideDownDuration: menuBar.slideDownDuration,
    isVisible: canShowMenuBar && (modal.isVisible || isMenuBarVisible),
    utilityButtons: React.createElement(React.Fragment, null, headerButtonsVariant('default'), React.createElement(My.UtilityButton, {
      menu: pinnedNavigationMenu,
      isMenuVisible: isMenuBarVisible && header.isPinnedNavigationMenuVisible,
      iconComponent: MenuIconGlyph,
      variant: "icon",
      onClick: header.onPinnedMenuButtonClick
    }, t('Sections'))),
    menuButtons: menuButtons('menu-bar')
  }), React.createElement(SliceLayout, {
    entity: sliceEntity,
    boundary: boundary
  }, header.isNavigationMenuVisible && React.createElement(DarkMode, null, React.createElement(My.NavigationMenuReveal, {
    showSidebar: true,
    hasNavigationMenu: header.showLinearNavigation,
    variant: isMenuBarVisible ? 'bar' : 'default',
    onCloseClick: header.onMenuButtonClick,
    ref: header.navigationMenuRef
  }, navigationMenu)), React.createElement(My.Layout, {
    ref: header.inViewRef
  }, React.createElement(My.Logo, __assign({
    sizeVariant: 'default'
  }, logoProps)), React.createElement(My.Body, null, React.createElement(ThemeModeProvider, {
    value: themeMode
  }, React.createElement(My.UtilityButtons, null, headerButtonsVariant('pinned')), React.createElement(My.NavigationAndControls, {
    variant: variant
  }, React.createElement(My.Navigation, null, menu && ((_a = menu.items) === null || _a === void 0 ? void 0 : _a.map(function (item) {
    var _a;
    var isAvailable = header.menuItemIsAvailable(item);
    if (!isAvailable) {
      return null;
    }
    var hasChildren = item.children && !!item.children.length;
    var isDisclosed = hasChildren && header.disclosedMenuItem === item.id;
    var isActive = hasChildren ? includes((_a = item.children) === null || _a === void 0 ? void 0 : _a.map(function (item) {
      return item.path;
    }), currentEntity && currentEntity.path) && !menu.items.some(function (item) {
      return item.path === (currentEntity === null || currentEntity === void 0 ? void 0 : currentEntity.path);
    }) : trim(item.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(item.path, '/');
    var onClick = hasChildren ? function () {
      header.setDisclosedMenuItem(isDisclosed ? '' : item.id);
    } : null;
    return React.createElement(My.NavigationItem, {
      key: item.id
    }, React.createElement(My.MenuItemLink, {
      onClick: onClick,
      variant: 'header',
      barHeight: header.barHeight,
      isActive: isActive,
      isDisclosed: isDisclosed,
      showActiveBar: header.showActiveBar,
      icon: hasChildren && React.createElement(Icons.ChevronDownIconGlyph, null),
      entity: item
    }), isDisclosed && React.createElement(My.NavigationItemChildren, {
      ref: header.navigationDisclosedItemRef
    }, item.children.map(function (child) {
      var _a;
      var item = __assign(__assign({}, child), {
        isActive: trim(child.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(child.path, '/'),
        isDisclosed: false,
        children: [],
        hasChildren: false
      });
      var href = item.url || item.path || ((_a = item.page) === null || _a === void 0 ? void 0 : _a.path);
      return React.createElement(My.MenuItemSubLink, {
        key: child.id,
        href: href,
        icon: item.__icon,
        label: child.name,
        onClick: function () {
          header.hideDisclosedMenuItem();
        },
        isActive: item.isActive,
        entity: item
      });
    })));
  })))), React.createElement(My.MenuButtons, null, menuButtons('header')))), React.createElement(DarkMode, null, env.ENABLE_LANG && header.isLangMenuVisible && React.createElement(My.LangMenuReveal, {
    variant: isMenuBarVisible ? 'bar' : 'default',
    onCloseClick: header.onLangButtonClick,
    ref: header.langMenuRevealRef
  }, React.createElement(My.LangMenu, {
    onItemClick: header.onLangButtonClick
  })), header.showFollow && header.isFollowMenuVisible && React.createElement(My.FollowMenuReveal, {
    variant: isMenuBarVisible ? 'bar' : 'default',
    onCloseClick: header.onFollowButtonClick,
    ref: header.followMenuRevealRef
  }, React.createElement(My.FollowMenu, {
    onItemClick: header.onFollowButtonClick
  })), header.showUtilities && header.isUtilityMenuVisible && React.createElement(My.UtilityMenuReveal, {
    variant: isMenuBarVisible ? 'bar' : 'default',
    onCloseClick: header.onUtilityMenuButtonClick,
    ref: header.utilityMenuRevealRef
  }, React.createElement(My.UtilityMenu, {
    onItemClick: header.onUtilityMenuButtonClick,
    items: header.utilityMenu
  })), header.showShare && header.isShareMenuVisible && React.createElement(My.ShareMenuReveal, {
    variant: isMenuBarVisible ? 'bar' : 'default',
    onCloseClick: header.onShareButtonClick,
    ref: header.shareMenuRevealRef
  }, React.createElement(My.ShareMenu, {
    onItemClick: header.onShareButtonClick
  })), header.showUser && header.isUserMenuVisible && React.createElement(My.UserMenuReveal, {
    variant: isMenuBarVisible ? 'bar' : 'default',
    onCloseClick: header.onUserButtonClick,
    ref: header.userMenuRevealRef
  }, React.createElement(My.UserMenu, {
    showTitle: true,
    onItemClick: header.onUserButtonClick
  })), header.showThemeMode && header.isThemeModeMenuVisible && React.createElement(My.ThemeModeMenuReveal, {
    variant: isMenuBarVisible ? 'bar' : 'default',
    onCloseClick: header.onThemeModeButtonClick,
    ref: header.themeModeMenuRef
  }, React.createElement(My.ThemeModeMenu, {
    showTitle: true,
    onItemClick: header.onThemeModeButtonClick
  }))))));
});
SiteHeaderLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72, templateObject_73, templateObject_74, templateObject_75, templateObject_76, templateObject_77, templateObject_78, templateObject_79, templateObject_80, templateObject_81, templateObject_82, templateObject_83, templateObject_84, templateObject_85, templateObject_86, templateObject_87, templateObject_88, templateObject_89, templateObject_90, templateObject_91, templateObject_92, templateObject_93, templateObject_94, templateObject_95, templateObject_96, templateObject_97, templateObject_98, templateObject_99, templateObject_100, templateObject_101, templateObject_102, templateObject_103, templateObject_104, templateObject_105, templateObject_106, templateObject_107;